module.exports = __webpack_public_path__ + "static/media/49.f9c06a04.JPG";